import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=7c07139a&"
import script from "./MainForm.vue?vue&type=script&lang=js&"
export * from "./MainForm.vue?vue&type=script&lang=js&"
import style0 from "./MainForm.vue?vue&type=style&index=0&id=7c07139a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports